import {
    HttpInterceptor,
    HttpHandler,
    HttpEvent,
    HttpRequest,
    HttpErrorResponse
  } from '@angular/common/http';
  import { Injectable } from '@angular/core';
  import { Router } from '@angular/router';
  import { Observable } from 'rxjs';
  import { tap } from 'rxjs/operators';
  
  
@Injectable()
export class ClientInterceptor implements HttpInterceptor {
  constructor(protected router: Router) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    let token = localStorage.getItem('token');
    const authReq = req.clone({
      headers: req.headers.set(
        'Authorization',
        token !== null ? token : ''
      )
    });

    return next.handle(authReq).pipe(
      tap(
        (event) => {
          // if (event instanceof HttpResponse)
        },
        (err) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status == 401) this.router.navigateByUrl('');
          }
        }
      )
    );
  }
}

